function numberValidator(input) {
  const regexpTest = /^[0-9]*$/;

  const isValid = input.length > 0 && regexpTest.test(input);

  return isValid;
}

export default numberValidator;
